import '../../css/Aviso.css';
export function mostrarAviso(mensaje, duracion){
    let aviso = document.querySelector("#toast-aviso");
    aviso.innerHTML = mensaje;
    aviso.classList.remove("d-none");
    setTimeout(() => { 
        aviso.style.opacity = 1;
        setTimeout(() => {
            aviso.style.opacity = 0;
            setTimeout(() => {
                aviso.classList.add("d-none");
            }, 400);
        }, duracion);
    }, 100);
}

export default function Aviso(){
return(
    <div id='toast-aviso' className="aviso alert alert-danger fw-bold d-none">
        
    </div>
);
}